import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import Footer from './components/footer/Footer';
import Header from './components/header/Header';
import DynamicStyle from './components/dynamicStyles';
import ContainerContent from './components/ContainerContent';
import {
  RootCalcWrapper,
  RootRedirect,
  ContainerWrapper,
  ScrollToTopWrapper,
  AuthGuard,
  PUBLIC_ROUTES
} from './components/AppComponents';

import Recommendations from './pages/recommendations/Recommendations';
import Indicators from './pages/indicators/Indicators';
import Subjects from './pages/subject/Subject';
import SubjectForm from './pages/subjectForm/SubjectForm';
import Interpretations from './pages/interpretations/Interpretations';
import Terms from './pages/legal/Terms';
import Privacy from './pages/legal/Privacy';
import Cookies from './pages/legal/Cookies';
import ThemesList from './pages/ThemesList';
import ThemeInfo from './pages/theme-info/ThemeInfo';
import Login from './pages/Login';
import Report from './pages/report/Report';
import Register from './pages/Register';
import RegisterSuccess from './pages/RegisterSuccess';
import ForgotPassword from './pages/ForgotPassword';
import VerifyEmail from './pages/VerifyEmail';
import ResetPassword from './pages/ResetPassword';
import Profile from './pages/Profile';
import Orders from './pages/Orders';
import MyReports from './pages/MyReports';
import MyReport from './pages/MyReport';
import AccountSettings from './pages/AccountSettings';
import Step2Page from './pages/theme-info/Step2Page';
import Step2CardA from './pages/theme-info/Step2CardA';
import Step2CardB from './pages/theme-info/Step2CardB';

import { initializeBiomarkers, fetchAppConfig } from './utils/appHelpers';
import { DesktopRecommendedBanner } from './components/modals/DesktopRecommendedModal';

import './App.css';
import { Background } from './styles/App.styles';

const App: React.FC = () => {
  const [configState, setConfigState] = useState<any>();

  console.log('App render');

  useEffect(() => {
    initializeBiomarkers();
  }, []);

  useEffect(() => {
    const fetchConfig = async () => {
      const response = await fetchAppConfig();
      if (response) {
        setConfigState(response);
      }
    };

    fetchConfig();
  }, []);

  // if (!configState) {
  //   return null;
  // }

  return (
    <Background data-bcg>
      <DynamicStyle />
      <BrowserRouter>
        <ScrollToTopWrapper />
        <DesktopRecommendedBanner />
        <Header />
        <AuthGuard>
          <Routes>
            <Route path='/' element={<RootRedirect />} />
            <Route path='/home' element={<ThemesList />} />
            <Route path='/theme-info' element={<ThemeInfo />} />
            <Route path='/report' element={<Report />} />
            <Route path='/login' element={<Login />} />
            <Route path='/register' element={<Register />} />
            <Route path='/register-success' element={<RegisterSuccess />} />
            <Route path='/forgot-password' element={<ForgotPassword />} />
            <Route path='/verify-email' element={<VerifyEmail />} />
            <Route path='/reset-password' element={<ResetPassword />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/orders" element={<Orders />} />
            <Route path="/my-reports" element={<MyReports />} />
            <Route path="/my-report" element={<MyReport />} />
            {/* <Route path="/account-settings" element={<AccountSettings />} /> */}

            {/* Protected routes with biomarker data */}
            <Route path={'/'} element={<RootCalcWrapper />}>
              <Route path='/biomarkers' element={<Indicators />} />
              <Route path='/summary' element={<Recommendations />} />
              <Route path='/theme/:themeId' element={<Interpretations />} />
            </Route>

            <Route path='/form' element={<SubjectForm />} />
            <Route path='/onboarding' element={<Navigate to='/home' replace />} />
            <Route path='/theme-info/step2' element={<Step2Page />} />
            <Route path='/themeInfo/step2/cardA' element={<Step2CardA />} />
            <Route path='/themeInfo/step2/cardB' element={<Step2CardB />} />

            {/* Public legal routes */}
            <Route path={'/'} element={<ContainerWrapper />}>
              <Route path='/terms-of-use' element={<Terms />} />
              <Route path='/privacy-policy' element={<Privacy />} />
              <Route path='/cookie-policy' element={<Cookies />} />
              <Route path='*' element={<Navigate to='/form' />} />
            </Route>
          </Routes>
        </AuthGuard>
        <Footer />
      </BrowserRouter>
    </Background>
  );
};

export default App;
